import * as types from '../constants/actionConstants';
import { createSingleAction } from '../../utils/reduxActions'

export const onSearchChallengeDetail = createSingleAction(types.loyaltyAccInfoConst.CHALLENGE_DETAIL);
export const onSearchChallengeDetailSuccess = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_FUNCTION_SUPPORT);
export const onSearchChallengeDetailErr= createSingleAction(types.loyaltyAccInfoConst.LOYALTY_SUPPORT_ERROR);

export const onSearchTransactionDetail = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_TRANSACTION);
export const onSearchTransactionDetailSuccess = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_TRANSACTION_SUCCESS);
export const onSearchTransactionDetailErr = createSingleAction(types.loyaltyAccInfoConst.LOYALTY_SUPPORT_ERROR);


export const getAllQuest = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_CHALLENGE);
export const getAllQuestSuccess = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_CHALLENGE_SUCCESS);
export const getAllQuestErr = createSingleAction(types.loyaltyAccInfoConst.LOYALTY_SUPPORT_ERROR);

export const getAllReward = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_REWARD);
export const getAllRewardSuccess = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_REWARD_SUCCESS);
export const getAllRewardErr = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_REWARD_ERROR);

export const getByGiftGroup = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GIFTGROUP);
export const getByGiftGroupSuccess = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GIFTGROUP_SUCCESS);
export const getByGiftGroupErr = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GIFTGROUP_ERROR);

export const getGiftInfors = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GIFTINFORS);
export const getGiftInforsSuccess = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GIFTINFORS_SUCCESS);
export const getGiftInforsErr = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GIFTINFORS_ERROR);

export const getAllWithImage = createSingleAction(types.loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE);
export const getAllWithImageSuccess = createSingleAction(types.loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE_SUCCESS);
export const getAllWithImageErr = createSingleAction(types.loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE_ERROR);

export const getGiftDetailByGroupAction = createSingleAction(types.loyaltyAccInfoConst.GIFT_GROUPDETAIL_GIFTGROUP);
export const getGiftDetailByGroupActionSuccess = createSingleAction(types.loyaltyAccInfoConst.GIFT_GROUPDETAIL_GIFTGROUP_SUCCESS);
export const getGiftDetailByGroupActionErr = createSingleAction(types.loyaltyAccInfoConst.GIFT_GROUPDETAIL_GIFTGROUP_ERROR);

export const getQuestAllAction = createSingleAction(types.loyaltyAccInfoConst.GIFT_QUEST_GETALL);
export const getQuestAllActionSuccess = createSingleAction(types.loyaltyAccInfoConst.GIFT_QUEST_GETALL_SUCCESS);
export const getQuestAllActionErr = createSingleAction(types.loyaltyAccInfoConst.GIFT_QUEST_GETALL_ERROR);

export const getProfileByC = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GETPROFILEBYC);
export const getProfileByCSuccess = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GETPROFILEBYC_SUCCESS);
export const getProfileByCErr = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_GETPROFILEBYC_ERROR);

export const getListMyGiftStoreAction = createSingleAction(types.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE);
export const getListMyGiftStoreActionSuccess = createSingleAction(types.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE_SUCCESS);
export const getListMyGiftStoreActionErr = createSingleAction(types.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE_ERROR);

export const getRedeemToken = createSingleAction(types.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE);
export const getRedeemTokenSuccess = createSingleAction(types.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE_SUCCESS);
export const getRedeemTokenErr = createSingleAction(types.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE_ERROR);

export const onClickScrollingMenu = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_SCROLLING_MENU);
export const onClickScrollingMenuSuccess = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_FUNCTION_SUPPORT);
export const onClickScrollingMenuErr = createSingleAction(types.loyaltyAccInfoConst.GET_LOYALTY_FUNCTION_SUPPORT_ERROR);

export const getListMyGiftGroupStoreAction = createSingleAction(types.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYGROUPCODE);
export const getListMyGiftGroupStoreActionSuccess = createSingleAction(types.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYGROUPCODE_SUCCESS);

export const resetStateAct = createSingleAction(types.loyaltyAccInfoConst.LOYALTY_ACC_INFO_RESET_STATE);
//


export function onDisplayAllRewardList(challenge) {
  return dispatch => {
    window.location.href ='/pages/loyalty-quest';
    }
}

//


//
export function onSearchRewadDetail() {
  return dispatch => {
    window.location.href ='/pages/reward-detail';
    }
}


export function onDetailPointRank() {
   
  window.location.href ='/pages/point-rank';
    
}
